import { call, put } from 'redux-saga/effects';
import { fetchAsioRolesForSubscribersSuccess, fetchAsioRolesForSubscribersFailure } from '../slice';
import { GET, getHeaders } from 'src/services/ApiService';

export function* fetchRoles(action) {
    const { id } = action.payload;
    const result = yield call(GET, `/iambff/v1/users/${id}/app-role-mappings?app_ids=asio_platform`, getHeaders());
    if (result.isSuccess) {
        yield put(
            fetchAsioRolesForSubscribersSuccess({
                data: result.response,
            })
        );
    } else {
        yield put(fetchAsioRolesForSubscribersFailure(result));
    }
}
